import React from 'react';
import Chart from 'react-apexcharts';

const LineChart = ({ title, series, categories}) => {
  const chartOptions = {
    chart: {
      type: 'line',
      height: 350,
      animations: {
        enabled: true,
        easing: 'easeout',
        speed: 800,
      },
    },
    stroke: {
      curve: 'smooth',
      width: 3,
    },
    colors: ['#3b82f6'], // Blue color, consistent with city-wise chart
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: categories || [],
      labels: {
        style: {
          fontSize: '10px', // Smaller font for up to 30 dates
          fontFamily: "'Inter', sans-serif",
          fontWeight: 500,
          colors: '#64748b',
        },
        rotate: -45, // Rotate labels for readability
        rotateAlways: true,
        trim: true,
        maxHeight: 100,
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: '12px',
          fontFamily: "'Inter', sans-serif",
          colors: '#64748b',
        },
        formatter: function (val) {
          return val.toLocaleString(); // Format large numbers (e.g., 1,200)
        },
      },
      title: {
        text: 'Followers',
        style: {
          fontSize: '14px',
          fontFamily: "'Inter', sans-serif",
          fontWeight: 600,
          color: '#1e293b',
        },
      },
    },
    grid: {
      borderColor: 'rgba(203, 213, 225, 0.3)',
      strokeDashArray: 5,
    },
    tooltip: {
      theme: 'dark',
      style: {
        fontSize: '12px',
        fontFamily: "'Inter', sans-serif",
      },
      x: {
        formatter: function (val) {
          return val; // Display date as is (e.g., "31 Jul 2025")
        },
      },
      y: {
        formatter: function (val) {
          return `${val.toLocaleString()} followers`; // Format tooltip
        },
      },
    },
    title: {
      text: title,
      align: 'center',
      style: {
        fontSize: '18px',
        fontFamily: "'Inter', sans-serif",
        fontWeight: 600,
        color: '#1e293b',
      },
    },
    legend: {
      show: true,
      position: 'top',
      fontSize: '14px',
      fontFamily: "'Inter', sans-serif",
      fontWeight: 500,
      labels: { colors: '#1e293b' },
    },
  };

  const chartSeries = [
    {
      name: series[0]?.name || 'Follower Count',
      data: series[0]?.data || [],
    },
  ];

  return (
    
    <div style={{ height: '400px', position: 'relative', padding: '16px' }}>
      <Chart options={chartOptions} series={chartSeries} type="line" height="100%" />
    </div>
  );
};

export default LineChart;